<template>
  <div>
    <div class="noteHolder">
      <div class="note rounded">
        <v-icon small color="red" class="float-right" @click="deleteNote()"
          >mdi-close</v-icon
        >
        <v-card-title class="mb-n6" v-if="note.billable_activity"
          >{{ note.billable_activity }}
        </v-card-title>
        <small class="ml-4">Bill: {{ getCurrency + note.amount }}</small><br><small class="ml-4">Date: {{ note.note_date }}</small>
        <textarea
          rows="2"
          id="note-1"
          @blur="updateNote()"
          v-model="note.description"
        >
        </textarea>
      </div>
    </div>
    <GlobalConfirmDeleteDialog
      :item="'Note'"
      @delete-confirmed="deleteNote"
    ></GlobalConfirmDeleteDialog>
  </div>
</template>

<script>
import axios from "@/plugins/axios";
import GlobalConfirmDeleteDialog from "@/components/myLibrary/GlobalConfirmDeleteDialog.vue";

export default {
  props: ["note"],
  components: { GlobalConfirmDeleteDialog },

  computed: {
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getCurrency() {
      return this.$store.getters.getCurrency;
    },
  },
  data: () => ({
    delNote: null,
  }),
  methods: {
    updateNote() {
      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken("/auth/save-note", this.note, this.getAccessToken)
        .then((notes) => {
          this.$store.commit("setLoader", false);
        });
    },
    openConfirmDeleteDialog() {
      this.delNote = this.note;
      this.$store.commit("setGlobalConfirmDelete", true);
    },
    deleteNote(choice) {
      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken("/auth/delete-note", this.note, this.getAccessToken)
        .then((notes) => {
          this.$emit("note-deleted", notes);
          this.$store.commit("setLoader", false);
        });
    },
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css?family=Handlee");
* {
  box-sizing: border-box;
}

.noteHolder {
  position: static;
  display: inline-block;
  width: 12em;
  height: 12em;
  font-family: "Handlee", cursive;
  margin: 15px;
  cursor: pointer;
  z-index: 600;
  overflow: hidden;
  /* 	box-shadow: 0px 0px 10px 2px #00000010; */
}

.note {
  position: relative;
  width: 100%;
  height: 100%;
  color: #4c4e67;
  background: #f1e000;
  overflow: hidden;
  padding: 0;
  font-size: 16px;
}

.note.rounded {
  -moz-border-radius: 5px 0 5px 5px;
  border-radius: 5px 36px 5px 5px;
}

.note textarea {
  border: none;
  background-color: transparent;
  width: 100%;
  height: 100%;
  resize: none;
  font-family: "Handlee", cursive;
  margin: 0px;
  padding: 10px;
  color: #2e2f3c;
  font-size: 16px;
}
.note textarea:focus {
  outline: none;
}
</style>
